import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData, getPressMedia} from '../utils/endpoints'
import { Container } from 'react-bootstrap';
import Loading from './components/loading';
import HeaderNotification from './components/headerNotification';
import Faqs from './components/faq';
import Header from './components/header';
import Footer from './components/footer';
import { Helmet } from 'react-helmet';

const Media = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const [pressMediaData, setPressMediaData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const pressMediaData = await getPressMedia(id);
            setPressMediaData(pressMediaData);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Things to do in nathdwara | nathdwara famous for</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <section className='section-breadcrumb'>
          <Container>
          <ul>
                <li><a href="/">Home</a></li>
                <li>Press & Media Release</li>
            </ul>
            <h1>Press & Media Release</h1>
          </Container>
        </section>
        <Container className='pt-5'>
        <div className='media-accordion'>
          {pressMediaData.map((item, key) => (
                <div className='itemWrapper' key={key}>
                    <a href={item?.acf?.media_url} target="_blank">
                      <h3 dangerouslySetInnerHTML={{ __html: item?.title?.rendered }}></h3>
                      <div className='itemBody'>
                          <div dangerouslySetInnerHTML={{ __html: item?.content?.rendered }} />
                      </div>
                    </a>
                </div>
            ))}
          </div>
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default Media;